(function() {
  // Prevent double loading logic
  if (window.CardV2Loaded) return;
  window.CardV2Loaded = true;

  // --- 1. Init Swipers Function ---
  window.initCardV2 = function(scope = document) {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper JS not loaded yet. Waiting...');
      setTimeout(() => window.initCardV2(scope), 200);
      return;
    }

    const swipers = scope.querySelectorAll('.product-card-swiper');
    
    swipers.forEach(el => {
      if(el.classList.contains('swiper-initialized')) return; 

      const startSlide = parseInt(el.getAttribute('data-initial-slide')) || 0;

      const swiper = new Swiper(el, {
        slidesPerView: 1,
        initialSlide: startSlide, 
        effect: 'fade', 
        fadeEffect: { crossFade: true },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
        },
        on: {
          slideChange: function () {
            const activeIndex = this.activeIndex;
            const activeSlide = this.slides[activeIndex];
            const colorValue = activeSlide.dataset.colorValue;
            const card = el.closest('.product-card-v2');

            if (colorValue && card) {
              const radio = card.querySelector(`input[type="radio"][value="${CSS.escape(colorValue)}"]`);
              if (radio) {
                radio.checked = true;
                const label = radio.closest('.product-card-swatch');
                card.querySelectorAll('.product-card-swatch').forEach(s => s.classList.remove('is-active'));
                if(label) label.classList.add('is-active');
              }

              // NEW: Update Selected Color Text dynamically!
              const selectedColorText = card.querySelector('[data-selected-color]');
              if (selectedColorText) {
                selectedColorText.textContent = colorValue;
              }
            }
          }
        }
      });
    });
  };

  // --- 2. Swatch Click Listener (Delegated) ---
  document.addEventListener('change', function(e) {
    if(e.target.name && e.target.name.startsWith('color-')) {
      const swatch = e.target.closest('.product-card-swatch');
      if (!swatch) return;
      
      const container = swatch.closest('.product-card-v2');
      if(!container) return;

      const colorValue = swatch.dataset.colorValue;
      
      // Update Visuals
      container.querySelectorAll('.product-card-swatch').forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      // Update Slider (which then triggers text update via slideChange)
      if (colorValue) {
        const swiperContainer = container.querySelector('.swiper');
        if (swiperContainer && swiperContainer.swiper) {
          const slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide'));
          const targetIndex = slides.findIndex(slide => slide.dataset.colorValue === colorValue);
          
          if (targetIndex >= 0) {
            swiperContainer.swiper.slideTo(targetIndex);
          }
        }
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    window.initCardV2();
  });

})();